import { render, staticRenderFns } from "./AutocompleteSuggetionList.vue?vue&type=template&id=25496520&"
import script from "./AutocompleteSuggetionList.vue?vue&type=script&lang=ts&"
export * from "./AutocompleteSuggetionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25496520')) {
      api.createRecord('25496520', component.options)
    } else {
      api.reload('25496520', component.options)
    }
    module.hot.accept("./AutocompleteSuggetionList.vue?vue&type=template&id=25496520&", function () {
      api.rerender('25496520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/lists/AutocompleteSuggetionList.vue"
export default component.exports